import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";

export const myStore = configureStore({
  reducer: rootReducer,
  devTools: false,
});

export type AppDispatch = typeof myStore.dispatch;
